import React, { useState } from 'react';

import CadastrarUsuario from './CadastrarUsuario';
import UsuariosCadastrados from './UsuariosCadastrados';

import * as S from './styles';

function GerenciarUsuarios() {
    const [activeTab, setActiveTab] = useState('1');
    const [editDataForm, setEditDataForm] = useState(false);

    return (
        <>
            <S.StyledTabs
                activeKey={activeTab}
                onChange={setActiveTab}
                defaultActiveKey="1"
                style={{ margin: '32px 122px' }}
            >
                <S.StyledTabPane tab="Cadastrar usuário" key="1">
                    <CadastrarUsuario
                        dataUser={editDataForm}
                        setEditDataForm={setEditDataForm}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                    />
                </S.StyledTabPane>

                <S.StyledTabPane tab="Usuários cadastrados" key="2">
                    <UsuariosCadastrados setEditDataForm={setEditDataForm} setActiveTab={setActiveTab} />
                </S.StyledTabPane>
            </S.StyledTabs>
        </>
    );
}

export default GerenciarUsuarios;
